import React, { FC, useContext, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { JWTToken, selfServiceClient } from '../components/services/selfService';
import { sessionRefreshTime } from './sessionRefreshTime';
import { useSsoSessionContext } from './SsoSessionContext';

const context = React.createContext<{
  shopToken?: JWTToken;
  isLoading: boolean;
  isError: boolean;
}>({
  isLoading: false,
  isError: false,
});

const tokenKey = 'kl.jwtToken';
export const ShopTokenContext: FC<{ shopToken?: JWTToken }> = ({ shopToken, ...props }) => {
  const { isLoggedIn } = useSsoSessionContext();

  const { data, isLoading, isError } = useQuery(['shopToken'], () => selfServiceClient.getToken(), {
    enabled: !shopToken && isLoggedIn,
    initialData: shopToken,
    refetchInterval: sessionRefreshTime,
  });
  useEffect(() => {
    data
      ? localStorage.setItem(tokenKey, JSON.stringify(data?.token))
      : localStorage.removeItem(tokenKey);
  }, [data]);
  return <context.Provider value={{ shopToken: data, isLoading, isError }} {...props} />;
};

export const useShopTokenContext = () => useContext(context);
